import React from 'react';
import { Trophy, Zap, Award } from 'lucide-react';
import { Card } from './ui/card';
import { Progress } from './ui/progress';

const GamificationBar = ({ points, level, badges }) => {
  const pointsForNextLevel = level * 100;
  const currentLevelPoints = points % 100;
  const progressPercentage = (currentLevelPoints / pointsForNextLevel) * 100;

  return (
    <Card className="p-4 bg-gradient-to-r from-amber-50/50 via-orange-50/30 to-yellow-50/50 dark:from-amber-950/20 dark:via-orange-950/20 dark:to-yellow-950/20 border-amber-200/50 dark:border-amber-800/30">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 dark:from-amber-500 dark:to-orange-600 text-white font-bold text-lg shadow-md flex-shrink-0">
            {level}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1.5">
              <h3 className="text-sm font-semibold text-foreground">Nível {level}</h3>
              <span className="text-xs text-muted-foreground">• {currentLevelPoints}/{pointsForNextLevel} XP</span>
            </div>
            <div className="w-full bg-white/60 dark:bg-black/20 rounded-full h-2 overflow-hidden">
              <div 
                className="h-full bg-gradient-to-r from-amber-500 to-orange-500 dark:from-amber-400 dark:to-orange-400 transition-all duration-500 rounded-full"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4 sm:gap-6">
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/60 dark:bg-white/5 border border-border/50">
            <Zap className="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0" />
            <div className="flex items-baseline gap-1">
              <span className="text-sm font-semibold text-foreground">{points}</span>
              <span className="text-xs text-muted-foreground">pts</span>
            </div>
          </div>
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/60 dark:bg-white/5 border border-border/50">
            <Award className="w-4 h-4 text-emerald-600 dark:text-emerald-400 flex-shrink-0" />
            <div className="flex items-baseline gap-1">
              <span className="text-sm font-semibold text-foreground">{badges.length}</span>
              <span className="text-xs text-muted-foreground hidden sm:inline">conquistas</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default GamificationBar;
